document.addEventListener( 'DOMContentLoaded', () => {
	const html = document.querySelector( 'html' );
	const menuButton = document.querySelector(
		'.wp-block-klingit-the-product-menu'
	);
	const menuContent =
		menuButton.parentElement.querySelector( '.menu-content' );
	const overlay = menuButton.parentElement.querySelector( '.overlay' );

	if ( menuButton && menuContent && overlay ) {
		menuButton.addEventListener( 'click', () => {
			if ( menuContent.classList.contains( 'hidden' ) ) {
				menuContent.classList.remove( 'hidden' );
				overlay.classList.remove( 'hidden' );

				setTimeout( () => {
					menuContent.classList.add( 'is-visible' );
					overlay.classList.add( 'is-visible' );
				}, 50 );
			} else {
				menuContent.classList.add( 'is-visible' );
				overlay.classList.add( 'is-visible' );
			}
			menuButton.setAttribute( 'aria-expanded', true );

			html.classList.add( 'is-scrolling-blocked' ); // to stop scrolling
		} );

		overlay.addEventListener( 'click', () => {
			menuButton.setAttribute( 'aria-expanded', false );
			menuContent.classList.remove( 'is-visible' );
			overlay.classList.remove( 'is-visible' );

			html.classList.remove( 'is-scrolling-blocked' ); // to remove scroll blocking
		} );
	}
} );
